import { render, staticRenderFns } from "./store_binding.vue?vue&type=template&id=0cece64c&scoped=true"
import script from "./store_binding.vue?vue&type=script&lang=js"
export * from "./store_binding.vue?vue&type=script&lang=js"
import style0 from "./store_binding.vue?vue&type=style&index=0&id=0cece64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cece64c",
  null
  
)

export default component.exports